<template>
  <section class="brandDetail">
    <canvas id="myCanvas" :width="width" :height="height" @click="toTouch" />
    <div class="show-text" v-if="custerInfo">剩余{{custerInfo.surplusActivityCount}}次免费机会</div>
    <van-popup  v-model="sucessDiagFlag">
      <div style="width:50px;height:50px;position:absolute;right:0" @click="sucessDiagFlag=false">
      </div>
      <img src="/images/game/sucess.png" alt="xiaog" class="dfewf" />
      <img class="code-img" v-if="gameInfo" :src="gameInfo.customerServiceQrCode" alt="">
      
    </van-popup>
    <van-popup  v-model="filedDiagFlag">
      <div style="width:50px;height:50px;position:absolute;right:0" @click="filedDiagFlag=false">
      </div>
      <img src="/images/game/filed.png" alt="xiaog" class="dfewfe" />
      <img src="/images/game/main/share.png" alt="xiaog" class="sharebon" @click="share" />
    </van-popup>
     <!-- <van-popup  v-model="restartDiaFlag">
      <div style="width:50px;height:50px;position:absolute;right:0" @click="restartDiaFlag=false">
      </div>
      <img src="/images/game/main/restart.png" alt="xiaog" class="disres" @click="status = true"/>
      
    </van-popup> -->
    <van-popup  v-model="noDO" :close-on-click-overlay="false" bind:close="onClose">
      <img src="/images/game/actityOver.png" alt="xiaog" class="dfewfe" />
    </van-popup>
    <van-popup  v-model="shareDialog" position="top" >
      <img src="/images/game/share.png" alt="xiaog" class="share-dialog" />
    </van-popup>
  </section>
  
</template>

<script>
import publicObj from "../../../assets/js/public";
import wxShare from "@/assets/js/wx.share";
import getWXConfig from '@/assets/js/wx.config'
import zhugeObj from "@/assets/js/track";
import gameApi from "@/axios/game";
let flagInterval= null
export default {
  name: "index",
  data() {
    return {
      noDO:false,
      shareDialog:false,
      sucessDiagFlag:false,
      filedDiagFlag:false,
      restartDiaFlag:false,
      loading:true,
      loadingFlag:false,
      creaBagIndex:0,
      loadingTime:0,
      ganY: 220/750*window.innerWidth+10,
      onOff: false,
      isSuccess:null,
      successTime:0,
      qianziStatus:0,
      qianziIndex:0,
      ganTop:212/750*window.innerWidth,
      moveTopFlag: false, //
      imgUrls: [
        ["button1", "/images/game/main/button1.png"],
        ["button2", "/images/game/main/button2.png"],
        ["ganzi", "/images/game/main/gan.png"],
        ["bg", "/images/game/bg.png"],
        ["dajiba", "/images/game/main/dajiba.png"],
        ["ground","/images/game/ground.png"],
        ["tuo","/images/game/main/tuo.png"],
        ["ybag","/images/game/main/ybag.png"],
        ["rbag","/images/game/main/rbag.png"],
        ["groundff","/images/game/ground-ff.png"],
        ["startButton","/images/game/main/startButton.png"]
      ],
      loadingImgs:[],
      redBags:[],
      time:0,
      countDown:0,
      imgMap: new Map(),
      bustatus:0,
      status:0,
      suFlag:true,
      gameInfo:{},
      custerInfo:null
    };
  },
  watch: {
    filedDiagFlag(val){
      if(!val){
        this.close()
        // this.restartDiaFlag=true
        this.status =0
      }
    },
    status(val){
      if(val){
        this.start()
      }else{
        this.gameOver()
      }
    },
    gameInfo(val){
      this.noDO = val?false:true
    },
    sucessDiagFlag(val){
      if(val){
        
      }
    }
  },
  computed: {
    plex(){
      return publicObj.isPlatform()
    }
  },
  created() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    getWXConfig(null,null,{title:"新年抓娃娃",link:window.location.href,imgUrl:"https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/img/WechatIMG261.png",desc:"166元等你来！"})
    let shareBody = {
        imgUrl:
          "https://baozheng-assets-new.oss-cn-beijing.aliyuncs.com/assets/bz/img/WechatIMG261.png",
        title: "新年抓娃娃",
        desc: "166元等你来！",
        link: window.location.href
        // link:
        //   "http://test.baozheng.cc/mentionMe/recipt-index?servicePhoneId=323"
      };
      wxShare(shareBody).then(()=>{
        
      });
  },
  mounted() {
    let text = this.$store.state.token?'是':'否'
    zhugeObj.track({
      title: "抓娃娃页面-曝光",
      '是否登录':text
    });
   
    let mycanvas = document.getElementById("myCanvas");
    this.ctx = mycanvas.getContext("2d");
    mycanvas.style.width = this.width + "px";
    mycanvas.style.height = this.height + "px";
    mycanvas.height = this.height * window.devicePixelRatio;
    mycanvas.width = this.width * window.devicePixelRatio;
    this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
    this.load();
    this.getInfo()
  },
  methods: {
    onClose(){
      this.noDO = true
    },
    getInfo(params){
      gameApi.activityInfo(params).then((res)=>{
          this.gameInfo = res
        }).catch((res)=>{
        })
    },
    getRecord(){
      return gameApi.searchRecord(this.gameInfo)
      // .then((res)=>{
      //     this.custerInfo = res
      // }).catch((res)=>{
      //   console.log(res)
      // })
    },
    getSuccessGame(){
      this.playCount(2).then(()=>{
        gameApi.successGame({activityId:this.gameInfo.id}).then((res)=>{
          this.sucessDiagFlag = true
        }).catch((res)=>{
        })
      })
    },
    playCount(type){
      let obj = {
        id:this.gameInfo.id,
        type
      }
      return gameApi.playCount(obj)
    },
    close(){
      this.sucessDiagFlag = false
      this.filedDiagFlag = false
      this.restartDiaFlag = false
    },
    toTouch(e) {
      let ganziWidth = 100;
      let ganziHeight = 100;
      let { x, y } = e;
      if(this.status){
        if (
          this.width / 2 - ganziWidth / 2 < x &&
          this.width / 2 + ganziWidth / 2 > x &&
          this.width*(900/750) < y &&
          this.width*(1100/750) > y
        ) {
          this.onOff = true
          this.qianziStatus=1
          this.bustatus = 1
          setTimeout(()=>{
            this.bustatus = 0
          },300)
        }
      }else{
        if (
          this.width / 2 - 257 / 2 < x &&
          this.width / 2 + 257 / 2 > x &&
          400 < y &&
          480 > y
        ) {
          zhugeObj.track({
            title: "抓娃娃页面开始按钮-点击"
          });
          this.getRecord().then((res)=>{
            console.log(res)
            this.custerInfo = res
            if(this.custerInfo.status==20){
              zhugeObj.track({
                title: "抓娃娃页面开始游戏",
                content: {
                  '状态': '已经抓取成功'
                }
              });
              this.sucessDiagFlag = true
            }else{
              if(this.custerInfo.surplusActivityCount){
                zhugeObj.track({
                  title: "抓娃娃页面开始游戏",
                  content: {
                    '状态': '正在进行'
                  }
                });
                this.status = true
              }else{
                zhugeObj.track({
                  title: "抓娃娃页面开始游戏",
                  content: {
                    '状态': '次数已用完'
                  }
                });
                this.filedDiagFlag = true
              }
            }
          })
        }
      }
    },
    load() {
      this.init();
      let index = 0;
      for (let imgUrl of this.imgUrls) {
        let img = new Image();
        img.src = imgUrl[1];
        img.onload = () => {
          this.imgMap.set(imgUrl[0], img);
          index++;
          if (index == this.imgUrls.length) {
            this.loading=false
          }
        };
      }
    },
    createRedBag(){
      if(this.time%130==0){
        this.creaBagIndex++
         let value = ''
        if(this.creaBagIndex%2==0){
          value='ybag'
        }else{
          value='rbag'
        }
        let obj = {
          x:this.width,
          disable:true,
          value
        }
        this.redBags.push(obj)
      }
      this.drawRedBag()
    },
    drawRedBag(){
      let bagSize = 80
      for(let ob of this.redBags){
        ob.x--
        if(ob.disable){
          this.ctx.drawImage(
            this.imgMap.get(ob.value),
            0,
            0,
            112,
            162,
            ob.x,
            this.width*(600/750),
            bagSize,
            bagSize*(162/112)
          );
        }
      }
       this.ctx.drawImage(
          this.imgMap.get("groundff"),
          0,
          0,
          1500,
          2208,
          0,
          0,
          this.width,
          this.width*(1100/750)
        );
      if(this.redBags[0]&&this.redBags[0].x<-100){
        this.redBags.shift();
      }
    },
    init() {
      this.draw();
    },
    drawButon() {
      let buSize = 100;
      if(!this.bustatus){
        this.ctx.drawImage(
          this.imgMap.get("button1"),
          0,
          0,
          208,
          156,
          this.width / 2 - buSize / 2,
          this.width*(900/750),
          buSize,
          buSize*(156/208)
        );
      }else{
        this.ctx.drawImage(
          this.imgMap.get("button2"),
          0,
          0,
          226,
          104,
          this.width / 2 - buSize / 2,
          this.width*(900/750)+30,
          buSize,
          buSize*(104/208)
        );
      }
    },
    drawBg(){
      this.ctx.drawImage(this.imgMap.get("bg"), 0, 0, this.width, this.height);
      this.ctx.drawImage(
        this.imgMap.get("ground"),
        0,
        0,
        750,
        1100,
        0,
        0,
        this.width,
        this.width*(1100/750)
      );
    },
    
    drawGetBag(y){
      let bagSize = 80
      if(this.isSuccess){
        this.ctx.drawImage(
          this.imgMap.get(this.isSuccess.value),
          0,
          0,
          112,
          162,
          this.width/2 - bagSize/2,
          y+60,
          bagSize,
          bagSize*(162/112)
        );
      }
    },
    drawGan(y) {
      let ganziWidth = 10;
      let tuoSize = 60
      this.ctx.drawImage(
        this.imgMap.get("ganzi"),
        0,
        0,
        24,
        y- this.ganTop,
        this.width / 2 - ganziWidth / 2,
        this.ganTop,
        ganziWidth,
        y- this.ganTop
      );
      this.ctx.drawImage(
        this.imgMap.get("tuo"),
        0,
        0,
        96,
        82,
        this.width / 2 - tuoSize/2,
        y,
        tuoSize,
        tuoSize*(81/96)
      );
    },
    drawGouzi(y) {
      y+=40
      let ganziWidth = 50;
      let ganziHeight = ganziWidth*(70/76);
      if(this.qianziStatus==0){
        this.ctx.save();
        this.ctx.translate(this.width / 2 -50, y);
        this.ctx.rotate(-this.qianziIndex*Math.PI/180);
        this.ctx.drawImage(
            this.imgMap.get("dajiba"),
            0,
            0,
            71,
            76,
            0,
            0,
            ganziWidth,
            ganziHeight
        );
        this.ctx.restore();
        this.ctx.save();
        this.ctx.translate(this.width / 2 , y);
        this.ctx.rotate(this.qianziIndex*Math.PI/180);
        this.ctx.drawImage(
            this.imgMap.get("dajiba"),
            71,
            0,
            71,
            76,
            0,
            0,
            ganziWidth,
            ganziHeight
        );
        this.ctx.restore();
      }
      if(this.qianziStatus==1){
        this.qianziIndex++
        this.ctx.save();
        this.ctx.translate(this.width / 2, y);
        this.ctx.rotate(this.qianziIndex*Math.PI/180);
        this.ctx.drawImage(
            this.imgMap.get("dajiba"),
            0,
            0,
            71,
            76,
            -ganziWidth,
            0,
            ganziWidth,
            ganziHeight
        );
        this.ctx.restore();
        this.ctx.save();
        this.ctx.translate(this.width / 2 , y);
        this.ctx.rotate(-this.qianziIndex*Math.PI/180);
        this.ctx.drawImage(
            this.imgMap.get("dajiba"),
            71,
            0,
            71,
            76,
            0,
            0,
            ganziWidth,
            ganziHeight
        );
        this.ctx.restore();
        if(this.qianziIndex>45){
            this.qianziStatus= 0
        }
      }
      if(this.qianziStatus==2){
        if(this.qianziIndex<0){
          this.qianziStatus= 0
        }else{
          this.qianziIndex-=2
        }
        this.ctx.save();
        this.ctx.translate(this.width / 2, y);
        this.ctx.rotate(-this.qianziIndex*Math.PI/180);
        this.ctx.drawImage(
            this.imgMap.get("dajiba"),
            0,
            0,
            71,
            76,
            -ganziWidth,
            0,
            ganziWidth,
            ganziHeight
        );
        this.ctx.restore();
        this.ctx.save();
        this.ctx.translate(this.width / 2 , y);
        this.ctx.rotate(this.qianziIndex*Math.PI/180);
        this.ctx.drawImage(
            this.imgMap.get("dajiba"),
            71,
            0,
            71,
            76,
            0,
            0,
            ganziWidth,
            ganziHeight
        );
        this.ctx.restore();
      }
    },
    drawLoading(){
      if(!this.loadingFlag){
        for(let i=1;i<42;i++){
          let img = new Image();
          img.src = `/images/game/loading/${i}.png`;
          img.onload = () => {
            this.loadingImgs.push(img)
            if(this.loadingImgs.length==40){
              this.loadingFlag = true
            }
          };
        }
      }else{
        if(this.loadingTime>40){
          this.loadingTime=0
        }
        this.ctx.clearRect(0,0, this.width,this.height);
        this.ctx.drawImage(
          this.loadingImgs[this.loadingTime],
          0,
          0,
          1000,
          1000,
          0,
          0,
          this.width,
          this.height
        );
        this.loadingTime++
      }
    },
    checkChiose(){
      this.suFlag = false
      if( this.qianziStatus!=2){
        for(let ob of this.redBags){
          if(Math.abs(ob.x+40-this.width/2)<10){
            ob.disable=false
            this.isSuccess = ob
            if(ob.value=='ybag'){
              this.successTime+=1
            }
            if(this.successTime==this.gameInfo.clipSuccessCount){
              this.status = false
              this.getSuccessGame()
            }
          }
        }
      }
    },
    drawText(){
      let x = 230*(this.width/750);
      let x1 = 670*(this.width/750);
      let y = 0
      if(this.plex=='ANDROID'){
        y= 125*(this.width/750)
      }else{
        y= 118*(this.width/750)
      }
      this.ctx.font = '16px "微软雅黑"';
			this.ctx.fillStyle = "#94045E";
			this.ctx.textBaseline = "top";
      this.ctx.fillText(this.successTime, x,y);
      
      
      this.ctx.font = '16px "微软雅黑"';
			this.ctx.fillStyle = "#94045E";
			this.ctx.textBaseline = "top";
      this.ctx.fillText(this.countDown+"s", x1,y);

    },
    drawStart(){
      this.ctx.fillStyle = "#00000054";
      this.ctx.fillRect(0, 0, this.width, this.height);
      this.ctx.drawImage(
        this.imgMap.get("startButton"),
        0,
        0,
        514,
        160,
        this.width/2 - 127,
        400,
        257,
        80
      );
    },
    drawMain(y) {
      this.drawBg();
      if(this.status){
        this.createRedBag();
        this.drawGetBag(y);
      }
      this.drawGouzi(y);
      this.drawGan(y);
      this.status&&this.drawButon();
      this.drawText();
      !this.status&&this.drawStart()
      this.time++
    },
    gameOver(){
      flagInterval&&clearInterval(flagInterval);
      this.countDown=0
      this.redBags = []
    },
    share(){
      zhugeObj.track({
        title: "抓娃娃页面邀请好友"
      });
      this.playCount(1).then(()=>{
        this.filedDiagFlag = false
        this.shareDialog=true
      })
    },
    start(){
      this.countDown=this.gameInfo.countDown
      this.successTime=0
      flagInterval&&clearInterval(flagInterval);
      flagInterval = setInterval(()=>{
        if(this.countDown==0){
          this.playCount(2)
          this.filedDiagFlag = true
          this.status = false
          clearInterval(flagInterval);
          return
        }
        this.countDown--
      },1000)
    },
    draw() {
      if(this.loading){
        this.time++
        // if(this.time%20==0){
        //   this.drawLoading()
        // }
        // if(this.time>10){
        //   this.loading=false
        // }
      }else{
        if (this.onOff) {
          if (this.moveTopFlag) { 
            this.ganY-=3;
            if (this.ganY < this.ganTop+10) {
              this.moveTopFlag = false;
              this.onOff = false;
              this.isSuccess = null
            }
          } else {
            if (this.ganY > (this.width*480/750)) {
              setTimeout(()=>{
                  this.moveTopFlag = true;
                  this.suFlag = true
              },200)
              this.suFlag&&this.checkChiose()
              this.qianziStatus=2
            }else{
              this.ganY+=5;
            }
          }
          this.drawMain(this.ganY);
        } else {
          this.drawMain(this.ganTop+10);
        }
      }
      window.requestAnimationFrame(this.draw);
    }
  }
};
</script>

<style scoped lang="scss">
canvas {
  display: block;
  background: #d6f8ff;
}
.dfewf{
  width:624px;
  height:828px;
}
.van-popup {
    background-color: #ff000000;
}
.dfewfe{
  width:622px;
  height:540px;
}
.disres{
  width:344px;
  height:94px;
}
.sharebon{
  width:340px;
  height:92px;
  position: relative;
  left: calc(50% - 170px);
  top: -160px;
}
.show-text{
  position:absolute;
  z-index:1111;
  top:1150px;
  height: 22px;
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
  width:100%;
  text-align: center;
}
.code-img{
  width:128px;
  height:128px;
  position: absolute;
  bottom: 100px;
  left:calc(50% - 64px)
}
.share-dialog{
  margin-top:50px;
  margin-left:calc(50% - 293px);
  width:587px;
  height:514px;
}
</style>

